
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/loader',['Vue'],function(Vue){
        return {
            template:template,
            props: ['loadingMessage', 'showLoader']
        }
    })
})('<div class="loadingIndicatorContainer" v-show="showLoader"> <div class="fetching-loader"> <div></div> <p>{{loadingMessage}}</p> </div> </div>');
